import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { streamActions } from '../../../../store/modules/stream';
import { projectSelectors } from '../../../../store/modules/project';

const useFetchProjectStreams = () => {
  const dispatch = useDispatch();
  const currentProject = useSelector(projectSelectors.selectCurrentProject);

  useEffect(() => {
    const projectStreams = currentProject?.extra.streams;
    if (!projectStreams) return;

    dispatch(streamActions.fetchStreamsByIds(projectStreams));
  }, [currentProject]);

  useEffect(() => {
    return () => {
      dispatch(streamActions.cleanProjectStreams());
    };
  }, []);
};

export default useFetchProjectStreams;
